<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md6 lg7 v-if="!projectButtonSelection || (projectButtonSelection && projectButtonSelection === 'TASKS')">
        <v-card>
        <v-toolbar color="secondary" dark>
          <v-btn icon large @click="displayType === 'list' ? displayType = 'box' : displayType = 'list'">
            <v-icon large>{{displayType === 'list' ? 'view_list' : 'view_module' }}</v-icon>
          </v-btn>
          <v-btn @click="showGantt = true" icon large><v-icon large>calendar_view_month</v-icon></v-btn>
          <v-toolbar-title>Task List</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon v-if="canEdit">
            <v-icon @click="createTaskDialog = true">add</v-icon>
          </v-btn>
          <v-menu offset-y :close-on-content-click="false">
            <v-btn slot="activator" icon>
              <v-icon>visibility</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="(item, index) in visabilityMenu" :key="index" @click="item.show = !item.show">
                <v-list-tile-title><v-icon :color="item.show === true ? 'orange' : 'grey'" class="mr-2">{{item.show === true ? 'check_box' : 'check_box_outline_blank'}}</v-icon>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          </v-toolbar>
          <div v-if="!project.tasks && canEdit && !loadedTasks" class="pt-3 pl-4 pr-4 title">
            <p>No Tasks Found. Please create a new task to start or create tasks from a task template.</p>
            <v-layout class="pl-4 pr-4" column v-if="canEdit">
              <div class="mt-5">
                <h4 v-if="project.status === 'Pre-Construction'">Pre-Construction Templates</h4>
                <v-select v-if="project.status === 'Pre-Construction'" v-model="taskTemplate" @change="showTaskTemplate = true" :items="templateDropdowns('Pre-Construction')" label="Select a Pre-Construction Template"></v-select>
              </div>
            </v-layout>
          </div>
        <!-- Shown if All Pre-Construction Tasks Completed -->
        <v-layout column v-if="project.status === 'Pre-Construction' && allTasksCompleted">
          <p class="title pa-3">Congratulations!</p>
          <p class="pa-3">You have completed the Pre-Construction phase. Are you ready to move this project to the construction phase?</p>
          <v-btn :disabled="!user.permissions.others.sendProjectToConstruction" @click="setConstructionStatus" color="primary">Send To Construction Phase</v-btn>
          <center v-if="!user.permissions.others.sendProjectToConstruction">* You must have the appropriate permissions to perform this action.</center>
        </v-layout>
        <!-- Shown if Waiting on Construction Template -->
        <v-layout column v-if="project.status === 'Construction' && project.waiting_on_template">
          <p class="title pa-3">This project is waiting on a new Construction Task Template.</p>
          <p v-if="canEdit" class="pa-3">Select a new template below.</p>
          <v-layout v-if="canEdit" class="pl-4 pr-4" column>
            <div v-if="canEdit" class="mt-5">
              <h4>Construction Templates</h4>
              <v-select v-model="taskTemplate" @change="showTaskTemplate = true; movingToConstruction = true" :items="templateDropdowns('Construction')" label="Select a Construction Template"></v-select>
            </div>
            <center v-if="!canEdit">* You must have the appropriate permissions to perform this action.</center>
          </v-layout>
        </v-layout>
        <v-layout column v-if="project.status === 'Construction' && allTasksCompleted && !project.waiting_on_template">
          <p class="title pa-3">Congratulations!</p>
          <p class="pa-3">You have completed all of the required tasks for this project!</p>
          <v-btn :disabled="!user.permissions.others.completeProject" @click="completeProject" color="primary">Mark Completed</v-btn>
          <center v-if="!user.permissions.others.completeProject">* You must have the appropriate permissions to perform this action.</center>
        </v-layout>
        <v-layout column v-if="project.status === 'Completed'">
          <p class="title pa-3">Project Complete!</p>
        </v-layout>
        <!-- End: Shown if All Pre-Construction Tasks Completed -->
        <!-- Build Task Display: List or Box -->
        <!-- List Type -->
        <v-list three-line v-if="tasks.length > 0 && displayType === 'list'">
          <template v-for="(task, index) in tasks">
            <v-list-tile :key="task.id" avatar style="border-radius: 10px; margin: 10px; border-width: 1px; border-style: solid" :style="{borderColor: statusBorders(task)}">
              <v-list-tile-content style="cursor: pointer" @click="editTask(task, index)">
                <v-list-tile-title v-html="task.name"></v-list-tile-title>
                <v-list-tile-sub-title>
                  <span :class="task.status === 'Completed' ? 'completed' 
                    : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 0 ? 'pastDue' 
                    : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 3 && ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 > -1 ? 'currentDue' 
                    : 'notDue'">
                    <span v-if="task.status === 'Completed'">Completed {{task.completed_date.seconds | moment("from")}}
                      <span class="caption font-weight-bold text--secondary ml-2">{{task.completed_date.seconds | moment("MMMM Do YYYY")}}</span>
                    </span>
                    <span v-if="task.status !== 'Completed' && !task.after_task">Due {{task.due_date.seconds | moment("from")}}</span>
                    <span class="caption" v-if="task.status !== 'Completed' && task.after_task">Due {{ task.days_due }} days after: {{ task.after_task_name }}</span>
                    <p style="margin-left: -8px;">
                      <span class="caption font-weight-bold text--secondary ml-2">{{task.status === 'Completed' ? task.completed_date.seconds : task.due_date.seconds | moment("MMMM Do YYYY")}}</span>
                      <span class="caption orange--text" v-if="task.status !== 'Completed' && task.is_double_booked">Note: Double Booked Task!</span>
                    </p>
                  </span>
                </v-list-tile-sub-title>
              </v-list-tile-content> 
              <v-menu offset-y>
                <v-btn @click="statusActivate(task)" slot="activator" class="white--text elevation-0" small :color="task.status.replace(' ', '')">{{ task.status }}</v-btn>
                <v-list class="text-xs-center" style="background-color: rgba(255, 255, 255, 0.95)">
                  <v-flex v-for="(status, index) in statusDropDown(task)" :key="index">
                    <v-btn @click="taskExecution(status)" class="text-xs-center" small outline :color="status.replace(' ', '')">{{ status }}</v-btn>
                  </v-flex>
                </v-list>
              </v-menu>
              <!-- Color Legend -->
            </v-list-tile>
          </template>
          <v-layout mb-3 justify-center mt-5>
            <v-flex xs12 class="text-xs-center">
              <v-chip class="white--text" color="NotStarted">Not Started</v-chip>
              <v-chip class="white--text" color="Started">Started</v-chip>
              <v-chip style="font-weight:900" color="OnHold">On Hold</v-chip>
              <v-chip class="white--text" color="PastDue">Past Due</v-chip>
              <v-chip class="white--text" color="Flagged">Flagged</v-chip>
              <v-chip class="white--text" color="Completed">Completed</v-chip>
            </v-flex>
          </v-layout>
        </v-list>
        <!-- Box Type -->
        <template v-if="tasks.length > 0 && displayType === 'box'">
          <v-layout row wrap>
            <v-flex class="taskBox" md12 lg6 xl4 v-for="(task, index) in tasks" :key="index">
              <v-toolbar class="boxToolbar" flat :class="statusColors(task)" height="40px" >
                <v-toolbar-title @click="editTask(task, index)" style="cursor: pointer" class="font-weight-bold subheading">{{ task.name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="user.permissions.others.fastTaskDeletion" small outline icon dark @click="selectedTask = task; taskExecution('Not Applicable')"><v-icon>clear</v-icon></v-btn>
              </v-toolbar>
              <v-toolbar flat height="30px" color="blue-grey lighten-3">
                <div style="margin-top: 5px;" v-if="task.assigned_to && task.assigned_to.length > 0" v-for="(user, i) in assignedUsers(task)" :key="i">
                <v-avatar style="margin-left: -20px;">
                  <v-tooltip top>
                    <avatar :size="24" slot="activator" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>{{ user.first_name + ' ' + user.last_name }}
                  </v-tooltip>
                </v-avatar>
                </div>
              </v-toolbar>
              <v-layout row v-if="task.is_double_booked">
               <v-flex xs12>
                <v-alert style="padding: 0px; margin: 0px;" :value="true" type="warning">*Double Booked Vendor</v-alert>
               </v-flex>
              </v-layout>
              <v-layout row wrap class="layoutBox" style="font-weight: 900; border-width: 1px; border-style: solid" :style="{borderColor: statusBorders(task)}">
                <v-layout row wrap>
                  <v-flex xs12 class="text-xs-center" @click="editTask(task, index)" style="cursor: pointer">
                    <v-icon size="24" class="mr-2" :class="task.status === 'Completed' ? 'completed' 
                    : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 0 ? 'pastDue' 
                    : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 3 && ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 > -1 ? 'currentDue' 
                    : 'notDue'">today
                    </v-icon>
                    <span :class="task.status === 'Completed' ? 'completed' : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 0 ? 'pastDue' : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 3 && ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 > -1 ? 'currentDue' : 'notDue'">
                      <span v-if="task.status === 'Completed'">Completed {{task.completed_date.seconds | moment("from")}}</span>
                      <span v-if="task.status !== 'Completed' && !task.after_task">Due {{task.due_date.seconds | moment("from")}}</span>
                      <span class="caption" v-if="task.status !== 'Completed' && task.after_task">Due {{ task.days_due }} days after: {{ task.after_task_name }}</span>
                    </span>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center">
                    <span v-if="task.status !== 'Completed'" class="caption font-weight-bold text--secondary ml-2">{{task.due_date.seconds | moment("MMMM Do YYYY")}}</span>
                    <span v-if="task.status === 'Completed'" class="caption font-weight-bold text--secondary ml-2">{{task.completed_date.seconds | moment("MMMM Do YYYY")}}</span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap mt-2 justify-center style="cursor: pointer" @click="editTask(task, index)">
                  <v-flex :class="countNotes(task) > 0 ? 'xs6' : 'xs12'" v-if="checklistItems(task.checklist) > 0">
                    <v-layout column>
                      <v-flex pt-3 xs12 class="text-xs-center">
                        <v-badge overlap color="primary">
                          <span slot="badge">{{checklistItems(task.checklist)}}</span>
                          <v-icon size="50" color="grey">check_box</v-icon>
                        </v-badge>
                      </v-flex>
                      <v-flex xs12 class="iconTextBox text-xs-center">
                        <span class="caption text-xs-center">CHECKLIST</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="countNotes(task) > 0">
                    <!-- <v-layout column> -->
                      <v-flex pt-3 xs12 class="text-xs-center">
                        <v-badge overlap color="primary">
                          <span slot="badge">{{ countNotes(task) }}</span>
                          <v-icon size="50" color="grey">library_books</v-icon>
                        </v-badge>
                      </v-flex>
                      <v-flex xs12 class="iconTextBox text-xs-center">
                        <span class="caption text-xs-center">TASK NOTES</span>
                      </v-flex>
                    <!-- </v-layout> -->
                  </v-flex>
                  <v-flex v-if="!checklistItems(task.checklist) > 0 && !countNotes(task) > 0">
                    <!-- <v-layout column> -->
                      <v-flex pt-3 xs12 class="text-xs-center">
                        <v-badge overlap color="primary">
                          <v-icon size="50" color="grey">list_alt</v-icon>
                        </v-badge>
                      </v-flex>
                      <v-flex xs12 class="iconTextBox text-xs-center">
                        <span class="caption text-xs-center">VIEW TASK</span>
                      </v-flex>
                    <!-- </v-layout> -->
                  </v-flex>
                  </v-layout>
                  <v-layout row style="width: 100%" v-if="project.status === 'Construction'">
                    <v-flex mt-3 xs12>
                      <v-btn v-if="!task.vendor_name" :disabled="!canEdit" @click="selectedTask = task; vendorSearch = true" style="width: 90%" outline>{{'No Vendor Assigned'}}</v-btn>
                      <v-btn v-if="task.vendor_name" :disabled="!canEdit" @click="selectedTask = task; vendorSearch = true" style="width: 90%" :style="task.vendor_name.length > 35 ? 'font-size:6px' : task.vendor_name.length > 30 ? 'font-size:8px' : task.vendor_name.length > 25 ? 'font-size:10px' : 'font-size:12px'" outline wrap>{{task.vendor_name}}<v-btn v-if="task.vendor_name" small icon light @click="selectedTask = task; removeVendor()"><v-icon>clear</v-icon></v-btn></v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row style="width: 100%">
                    <v-flex mt-3 xs12 class="text-xs-center">
                      <v-menu offset-y>
                        <v-btn :disabled="!canEdit" @click="statusActivate(task)" slot="activator" outline :color="task.status.replace(' ', '')">{{ task.status }}</v-btn>
                        <v-list class="text-xs-center" style="background-color: rgba(255, 255, 255, 0.95)">
                          <v-flex v-for="(status, index) in statusDropDown(task)" :key="index">
                            <v-btn :disabled="!canEdit" @click="taskExecution(status)" class="text-xs-center" small outline :color="status.replace(' ', '')">{{ status }}</v-btn>
                          </v-flex>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
              </v-layout>
            </v-flex>
            <!-- Color Legend -->
            <v-layout row wrap mb-3 justify-center mt-5>
              <v-flex xs12 class="text-xs-center">
                <v-chip class="white--text" color="NotStarted">Not Started</v-chip>
                <v-chip class="white--text" color="Started">Started</v-chip>
                <v-chip style="font-weight:900" color="OnHold">On Hold</v-chip>
                <v-chip class="white--text" color="PastDue">Past Due</v-chip>
                <v-chip class="white--text" color="Flagged">Flagged</v-chip>
                <v-chip class="white--text" color="Completed">Completed</v-chip>
              </v-flex>
            </v-layout>
        </v-layout>
      </template>
      <!-- End: Task Lists and Boxes -->
      </v-card>
      </v-flex>
      <v-flex xs12 md6 lg5 pl-2 v-if="!projectButtonSelection || (projectButtonSelection && projectButtonSelection === 'NOTES')">
        <v-layout row>
          <v-flex>
            <v-card>
              <!-- Notes -->
              <v-toolbar color="secondary" dark>
                <v-icon dark left>library_books</v-icon>
                <v-toolbar-title>Project Notes</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="canEdit" @click="showNoteForm = true" icon>
                  <v-icon>add</v-icon>
                </v-btn>
              </v-toolbar>
              <v-layout v-if="showNoteForm" row wrap>
                <v-flex xs12 pt-3 pl-3 pr-3>
                  <v-textarea outline v-model="newNote" label="Add A New Note"></v-textarea>
                </v-flex>
                <v-flex xs12 pl-3>
                  <v-checkbox class="mt-0 pt-0 pb-0" label="Notify Assigned Users" v-model="noteNotifyAssigned" />
                  <v-checkbox class="mt-0 pt-0" label="Notify All Users" v-model="noteNotifyAll" />
                </v-flex>
                <v-layout ml-3 mb-3 row>
                  <v-btn @click="addNote" class="primary">SAVE NOTE</v-btn>
                  <v-btn @click="showNoteForm = false" class="secondary">CANCEL</v-btn>
                </v-layout>
              </v-layout>
              <v-divider v-if="showNoteForm" class="mb-3"></v-divider>
              <div class="pb-4">
                <template v-for="(note, index) in projectNotes">
                  <v-subheader style="background: #616161" class="font-weight-black mt-3 white--text" v-if="note.header" :key="note.header">{{ note.header }}</v-subheader>
                  <div v-else class="mt-4" :key="index" avatar>
                    <v-layout row>
                    <div class="ml-2" style="float: left">
                      <v-avatar><v-tooltip top><avatar slot="activator" :username="note.userFullName" :src="note.avatar ? note.avatar : undefined"></avatar>{{ note.userFullName }}</v-tooltip></v-avatar>
                    </div>
                    <div class="ml-3">
                      <div class="primary--text font-weight-bold">
                        {{ note.created_date.seconds | moment("from") }} {{ note.created_date.seconds | moment("MM/DD/YY") }}
                        <v-tooltip bottom v-if="note.flagged">
                          <v-icon slot="activator" color="red" dark>flag</v-icon>
                          <span>{{note.flagged}}</span>
                        </v-tooltip>
                        <v-btn v-if="canEdit" icon><v-icon small @click="deleteNote(note)">cancel</v-icon></v-btn>
                      </div>
                      <div class="black--text"><span v-if="note.task_name" class="purple--text font-weight-bold">{{ note.task_name }} - </span>{{ note.note }}</div>
                    </div>
                    </v-layout>
                    <!-- <v-list-tile-action>
                      <v-btn v-if="canEdit" icon><v-icon @click="deleteNote(note)">clear</v-icon></v-btn>
                    </v-list-tile-action> -->
                  </div>
                </template>
                <span v-if="projectNotes.length < 1" class="ml-3 title">There are no notes for this project</span>
              </div>
              <!-- End: Notes -->
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- Task Dialog Box -->
      <v-dialog v-if="editTaskDialog" v-model="editTaskDialog" width="800px" content-class="white">
        <edit-task @addNote="addNote" @executeAllDateChanges="executeAllDateChanges" @closeTaskDialog="editTaskDialog = false" :project="project" :taskId="selectedTaskId" :taskIndex="selectedTaskIndex" :projectNotes="projectNotes" :tasks="tasks" />
      </v-dialog> 
    <!-- End: Task Dialog Box -->
    <!-- Vendor Search Dialog Box -->
      <v-dialog v-if="vendorSearch" v-model="vendorSearch" width="600px" height="400px">
        <vendor-search v-if="vendorSearch" @closeDialog="vendorSearch = false" @emittedVendor="emittedVendor" :project="project" :task="selectedTask" />
      </v-dialog>
    <!-- End: Vendor Search Dialog Box -->
    <!-- Create Task Dialog -->
    <v-dialog max-width="800px" persistent v-model="createTaskDialog" v-if="createTaskDialog">
      <create-task :project="project" :tasks="tasks" @closeDialog="createTaskDialog = false"/>
    </v-dialog>
    <!-- Create From Task Templates -->
    <v-dialog max-width="1000px" persistent v-model="showTaskTemplate" v-if="showTaskTemplate">
      <task-templates :project="project" :movingToConstruction="movingToConstruction" :taskTemplate="taskTemplate" @closeDialog="showTaskTemplate = false" @loadedTasks="loadedTasks = true" @updateConstructionStatus="updateConstructionStatus" />
    </v-dialog>
    <!-- Start: GANTT VIEW -->
    <v-dialog max-width="1400px" persistent v-model="showGantt" v-if="showGantt">
      <v-toolbar color="secondary" dark>
      <v-toolbar-title>Project Gantt Chart</v-toolbar-title>
       <v-spacer></v-spacer>
        <v-btn icon v-if="canEdit"><v-icon @click="showGantt = false">cancel</v-icon></v-btn>
      </v-toolbar>
      <scheduler :projectView="project"></scheduler>
    </v-dialog>
    <!-- END: GANTT VIEW -->
  </div>
</template>

<script>
import _ from 'lodash'
import Avatar from 'vue-avatar'
import EditTask from '../tasks/EditTask'
import VendorSearch from '../vendors/VendorSearch'
import CreateTask from '../tasks/CreateTask'
import TaskTemplates from './ProjectTaskTemplate'
import Scheduler from '../scheduling/Scheduler'
// import { db } from '../../firebaseInit'
export default {
  props: ['project', 'projectButtonSelection'],
  mounted () {
    if (this.project.status === 'Construction') {
      this.displayType = 'box'
    } else {
      this.displayType = 'list'
    }
  },
  data () {
    return {
      showGantt: false,
      loadedTasks: false,
      movingToConstruction: false,
      showTaskTemplate: false,
      noteNotifyAll: false,
      noteNotifyAssigned: false,
      createTaskDialog: false,
      selectedTaskId: null,
      selectedTaskIndex: null,
      selectedTask: null,
      vendorSearch: false,
      showActive: true,
      visabilityMenu: [ {name: 'Not Started', show: true},
                        {name: 'Started', show: true},
                        {name: 'On Hold', show: true},
                        {name: 'Flagged', show: true},
                        {name: 'Completed - Pre-Construction', show: false},
                        {name: 'Completed - Construction', show: false},
                        {name: 'Not Applicable', show: false}],
      newNote: null,
      showNoteForm: false,
      editTaskDialog: false,
      taskDialog: false,
      displayType: 'box', // list or box
      taskTemplate: null
    }
  },
  watch: {
    noteNotifyAssigned () {
      if (this.noteNotifyAssigned) {
        this.noteNotifyAll = false
      }
    },
    noteNotifyAll () {
      if (this.noteNotifyAll) {
        this.noteNotifyAssigned = false
      }
    }
  },
  computed: {
    canEdit () {
      return this.permissions.edit.all || (this.permissions.edit.assigned && this.project.assigned)
    },
    permissions () {
      return this.$store.getters.user.permissions.projects
    },
    allTasksCompleted () {
      const projectTasks = this.$store.getters.projectTasks
      if (projectTasks.length < 1) {
        this.$store.dispatch('getTemplates')
        return
      }
      const completedTasks = projectTasks.filter(f => f.deleted === false && (f.status === 'Completed' || f.status === 'Not Applicable'))
      return completedTasks.length === projectTasks.length
    },
    projectNotes () {
      const getNotes = this.$store.getters.projectNotes
      const users = this.$store.getters.userList.concat(this.$store.getters.inactiveUsers)
      let notes = []
      getNotes.forEach(note => {
        const user = users.filter(f => f.id === note.created_by)
        notes.push({...note, avatar: user[0].avatar, userFullName: user[0].first_name + ' ' + user[0].last_name})
      })
      notes = _.orderBy(notes, 'created_date', ['desc'])
      // Organize into Phases //
      // Pre-Construction
      let completedcon = notes.filter(f => f.phase === 'Completed')
      if (completedcon.length > 0) {
        completedcon.unshift({header: 'Completed'})
      }
      let con = notes.filter(f => f.phase === 'Construction')
      if (con.length > 0) {
        con.unshift({header: 'Construction'})
      }
      let preCon = notes.filter(f => f.phase === 'Pre-Construction')
      if (preCon.length > 0) {
        preCon.unshift({header: 'Pre-Construction'})
      }
      let leads = notes.filter(f => f.phase === 'Leads')
      if (leads.length > 0) {
        leads.unshift({header: 'Leads'})
      }
      const results = completedcon.concat(con, preCon, leads)
      return results
      // return _.orderBy(results, 'created_date', ['desc'])
    },
    proceed () {
      return this.$store.getters.proceed
    },
    tasks () {
      let returnTasks = []
      if (this.visabilityMenu[0].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {status: 'Not Started'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      if (this.visabilityMenu[1].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {status: 'Started'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      if (this.visabilityMenu[2].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {status: 'On Hold'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      if (this.visabilityMenu[3].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {status: 'Flagged'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      if (this.visabilityMenu[4].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {type: 'Pre-Construction', status: 'Completed'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      if (this.visabilityMenu[5].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {type: 'Construction', status: 'Completed'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      if (this.visabilityMenu[6].show === true) {
        const taskStatus = _.filter(this.$store.getters.projectTasks, {status: 'Not Applicable'})
        returnTasks = returnTasks.concat(taskStatus)
      }
      // Get after_task_name
      returnTasks.forEach((task, i) => {
        if (task.after_task) {
          const afterTask = returnTasks.filter(f => f.id === task.after_task)[0]
          if (afterTask && afterTask.name) {
            returnTasks[i].after_task_name = afterTask.name
          }
        }
      })
      return _.orderBy(returnTasks, ['due_date.seconds', 'name'])
    },
    dateDifference (value) {
      // Passing a Firebase Date Object due_date.seconds
      return Math.floor((new Date() - value) / 86400000)
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    checkVendorDoubleBooking (taskId, isDoubleBooked, vendorId, dueDate) {
      if (vendorId) {
        const payload = { taskId, isDoubleBooked, vendorId, dueDate: new Date(dueDate.seconds * 1000), ifProjectTasks: true }
        this.$store.dispatch('checkVendorDoubleBooked', payload)
      } else {
        this.$store.commit('checkVendorDoubleBooked', null)
      }
    },
    templateDropdowns (type) {
      let getTemplates = this.$store.getters.getTemplates
      getTemplates = getTemplates.filter(f => f.deleted === false && f.active === true && f.type === type)
      return getTemplates.map(template => ({ text: template.name, value: template.id }))
    },
    assignedUsers (task) {
      let assigned = []
      if (task.assigned_to) {
        task.assigned_to.forEach(user => {
          assigned.push(this.$store.getters.userList.concat(this.$store.getters.inactiveUsers).filter(f => f.id === user)[0])
        })
        return assigned
      } else {
        return assigned
      }
    },
    removeVendor () {
      const payload = {task: this.selectedTask, project: this.project, vendor: this.selectedTask.vendor_name}
      this.$store.dispatch('removeVendorFromTask', payload)
      this.$store.dispatch('updateFilteredTasks', this.selectedTask)
      this.$store.commit('checkVendorDoubleBooked', null)
    },
    executeAllDateChanges (payload) { // Executed from the edit task dialog - on parent because all dates change on the project
      const shiftTaskDates = this.tasks.slice(payload.taskIndex)
      shiftTaskDates.forEach((task, index) => {
        shiftTaskDates[index].due_date.seconds = shiftTaskDates[index].due_date.seconds + (payload.dueDateDifference * 86400)
        const newDueDate = new Date(shiftTaskDates[index].due_date.seconds * 1000)
        const startDate = task.start_date && task.start_date.seconds ? task.start_date.seconds : this.project.start_date.seconds
        const dueDateDifference = Math.abs(new Date(startDate * 1000) - newDueDate)
        const daysDue = Math.floor(dueDateDifference / (1000 * 60 * 60 * 24))
        shiftTaskDates[index].days_due = daysDue
      })
      const storePayload = {tasks: shiftTaskDates, project: this.project, dayShift: payload.dueDateDifference}
      this.$store.dispatch('executeAllDateChanges', storePayload)
    },
    completeProject () {
      this.$store.dispatch('completeProject', this.project)
    },
    deleteNote (note) {
      if (confirm('Are you sure you want to delete the note: ' + note.note + '?')) {
        this.$store.dispatch('deleteProjectNote', {note: note, project: this.project})
      }
    },
    updateConstructionStatus () {
      this.$store.dispatch('projectUpdate', {project: this.project, newState: {waiting_on_template: false}, previousState: {status: this.project.status}})
      this.notifyAllUsers()
    },
    setConstructionStatus () {
      this.$store.dispatch('projectUpdate', {project: this.project, newState: {status: 'Construction', waiting_on_template: true}, previousState: {status: this.project.status}})
      this.notifyAllUsers()
    },
    notifyAllUsers () { // This was changed to only notify Assigned Users on 12/18/2019 by Wes Issue #41
      let users = Object.assign([], this.$store.getters.userList)
      let emails = []
      this.project.assigned_to.forEach(assigned => {
        const userEmail = users.filter(f => f.id === assigned)[0]
        if (userEmail) {
          emails.push(userEmail.email)
        }
      })
      emails.splice(users.findIndex(i => i.id === this.$store.getters.user.id), 1)
      if (emails.length > 0) {
        const emailSubject = 'Project: ' + this.project.name + ' Moved To The Construction Phase'
        const title = this.user.first_name + ' ' + this.user.last_name + ' Has Moved The Project: ' + this.project.name + ' To The Construction Phase'
        const message = 'There is a new project: ' + this.project.name + ' that was just moved to the construction phase. Please review if you have required tasks due.'
        const url = this.$store.getters.clientSettings.baseUrl + '/project/' + this.project.id
        const icon = 'ballot'
        this.$store.dispatch('notify', {emails, emailSubject, title, message, url, icon})
      }
    },
    countNotes (task) {
      let numberOfNotes = _.filter(this.projectNotes, {task_id: task.id})
      numberOfNotes = numberOfNotes.length
      return numberOfNotes
    },
    // Added as VUEX is not automatically changing the task object
    emittedVendor (vendor) {
      this.checkVendorDoubleBooking(this.selectedTask.id, this.selectedTask.is_double_booked, vendor.id, this.selectedTask.due_date)
    },
    statusDropDown (task) {
      if (task.if_na === true) {
        return ['Not Started', 'Started', 'On Hold', 'Flagged', 'Not Applicable']
      } else {
        return ['Not Started', 'Started', 'On Hold', 'Flagged']
      }
    },
    addNote (task) {
      const note = task.note ? task.note : this.newNote
      if (note) {
        let payload = {project_id: this.project.id, note: note, project_name: this.project.name, task_id: task.task_id, task_name: task.task_name, phase: this.project.status}
        if (this.noteNotifyAll || this.noteNotifyAssigned) {
          payload = {...payload, flagged: this.noteNotifyAssigned ? 'Notified Assigned Users' : 'Notified All Users'}
        }
        if (task.flagged) {
          payload = {...payload, flagged: task.flagged}
        }
        this.$store.dispatch('addProjectNote', payload)
        this.newNote = null
        this.showNoteForm = false
        // Send Notifications if Any
        if (this.noteNotifyAll || this.noteNotifyAssigned || task.flagged) {
          let emails = []
          // Get Notification Emails
          let users = Object.assign([], this.$store.getters.userList)
          // Filter Out The Current User
          users.splice(users.findIndex(i => i.id === this.$store.getters.user.id), 1)
          if (this.noteNotifyAll || task.flagged === 'Notified All Users') {
            emails = users.map(user => user.email)
          }
          if (this.noteNotifyAssigned || task.flagged === 'Notified Assigned Users') {
            this.project.assigned_to.forEach(assigned => {
              const userEmail = users.filter(f => f.id === assigned)[0]
              if (userEmail) {
                emails.push(userEmail.email)
              }
            })
          }
          if (emails.length > 0) {
            const emailSubject = 'New Note Added To Project: ' + this.project.name
            const title = this.user.first_name + ' ' + this.user.last_name + ' Added A New Note To The Project: ' + this.project.name
            const message = note
            const url = this.$store.getters.clientSettings.baseUrl + '/project/' + this.project.id
            const icon = 'library_books'
            this.$store.dispatch('notify', {emails, emailSubject, title, message, url, icon})
            this.noteNotifyAll = false
            this.noteNotifyAssigned = false
          }
        }
      }
    },
    editTask (task, index) {
      // this.selectedTask = Object.assign({}, task)
      this.selectedTaskId = task.id
      this.selectedTaskIndex = index
      this.editTaskDialog = true
    },
    checklistItems (checklist) {
      if (checklist) {
        let activeChecklist = checklist.filter(f => f.active && !f.completed)
        return activeChecklist.length
      } else {
        return 0
      }
    },
    statusActivate (task) {
      this.selectedTask = Object.assign({}, task)
    },
    taskExecution (status) {
      if (status === 'Not Applicable') {
        const payload = { task: this.selectedTask, project: this.project, status: status }
        this.$store.dispatch('completeTask', payload)
      } else {
        const payload = { id: this.selectedTask.id, status: status }
        this.$store.dispatch('editTask', payload)
      }
    },
    statusColors (task) {
      if (task.status === 'Flagged') {
        return ['Flagged', 'white--text']
      } else if (task.status === 'Completed') {
        return ['Completed', 'white--text']
      } else if (task.status === 'On Hold') {
        return ['OnHold', 'black--text']
      } else if (task.due_date.seconds < new Date().getTime() / 1000) {
        return ['PastDue', 'white--text']
      } else if (task.status === 'Not Started') {
        return ['NotStarted', 'white--text']
      } else if (task.status === 'Started') {
        return ['Started', 'white--text']
      }
    },
    statusBorders (task) {
      if (task.status === 'Flagged') {
        return this.$vuetify.theme.Flagged
      } else if (task.status === 'Completed') {
        return this.$vuetify.theme.Completed
      } else if (task.status === 'On Hold') {
        return this.$vuetify.theme.OnHold
      } else if (task.due_date.seconds < new Date().getTime() / 1000) {
        return this.$vuetify.theme.PastDue
      } else if (task.status === 'Not Started') {
        return this.$vuetify.theme.NotStarted
      } else if (task.status === 'Started') {
        return this.$vuetify.theme.Started
      }
    },
    buildTaskList () {
      if (this.taskTemplate) {
        this.$store.dispatch('setProceed', false)
        const payload = {projectId: this.project.id, projectName: this.project.name, taskTemplate: this.taskTemplate, startDate: new Date()}
        this.$store.dispatch('getTaskList', payload)
        this.buildTaskListProceed()
      }
    },
    buildTaskListProceed () {
      if (this.proceed) {
        this.confirmTaskTemplate = false
        this.$store.dispatch('getProject', this.project.id)
        this.$store.dispatch('setProceed', false)
        if (this.project.status === 'Waiting On Construction') {
          setTimeout(() => {
            this.$store.dispatch('projectUpdate', {project: this.project, newState: {status: 'Construction'}, previousState: {status: this.project.status}})
            this.project.status = 'Construction'
            this.$store.dispatch('getProject', this.project.id)
          }, 3000)
        }
      } else {
        setTimeout(() => {
          this.buildTaskListProceed()
        }, 1000)
      }
    }
  },
  components: {
    Avatar,
    EditTask,
    VendorSearch,
    CreateTask,
    TaskTemplates,
    Scheduler
  }
}
</script>

<style 
    TaskTemplatesscoped>
.iconTextBox {
  color: white;
  margin-right: 15px;
  margin-left: 15px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  font-weight: 900;
}
.boxToolbar {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.v-chip {
  margin-left: 2px;
  margin-right: 2px;
}
.layoutBox {
  height: 315px;
  background-color: #fafafa;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.taskBox {
  padding-right: 5px;
  padding-left: 5px;
  padding-top: 10px;
}
.completed {
  color: #4caf50;
  font-size: 16px;
}
.pastDue {
  color: red;
  font-size: 16px;
}
.currentDue {
  color: orange;
  font-size: 16px;
}
.notDue {
  color: green;
  font-size: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/projects/ProjectTasks.vue